<template>
    <div class="page dashboard product-product-dashboard">
      <div class="content">
        <div
          v-if="isActionMenuOpen"
          class="action-menu-backdroup"
          v-on:click="toggleActionMenu('')"
        ></div>
        <div class="title-bar">
          <p class="title">Setting, Product Promotion</p>
          <div class="group">
            <div class="btn new">
              <div class="icon"></div>
              <p class="label" v-on:click="toggleActionMenu('new')">
                Add New
              </p>
            </div>
          </div>
        </div>
        <ListingComponent
          model="data"
          :isLoading="false"
          :data="{data:data, pageMeta: pageMeta}"
          :query.sync="query"
          :refresh="getData"
          :toggleActionMenu="handleDataClick"
          :listingOptions="listingOptions"
          :deleteRecord="deleteData"
        />
      </div>
      <div :class="`action-menu ${isActionMenuOpen ? 'active' : ''}`">
        <div class="btn close" v-on:click="toggleActionMenu('')"></div>
        <SettingPromotionLocalProductNew
          v-if="isActionMenuOpen === 'new' || isActionMenuOpen === 'edit'"
          :editItem="editItem"
          :addNewSuccess="addNewSuccess"
        />
        <!-- <EditCategory
          v-if="isActionMenuOpen === 'read'"
          :productGroup="focusedCategoryGroup"
          :editCategory="editCategory"
        /> -->
      </div>
    </div>
  </template>
  
  <script>
  import ListingLoadingComponent from "../../components/ListingLoadingComponent";
  import TabBarLoadingComponent from "../../components/TabBarLoadingComponent";
  import ListingComponent from "../../components/ListingComponent";
  import TabBarComponent from "../../components/TabBarComponent";
  
  import SettingPromotionLocalProductNew from "./SettingPromotionLocalProductNew";
  export default {
    name: "SettingPromotionLocalProductDashboard",
    components: {
      ListingLoadingComponent,
      TabBarLoadingComponent,
      ListingComponent,
      TabBarComponent,
      SettingPromotionLocalProductNew,
    },
    data: function () {
        return {
            query: {
                order: "ASC",
                page: 1,
                limit: 10,
                sortBy: "",
                status: 0,
            },
            editItem: "",
            isActionMenuOpen: ""
        };
    },
    created() {
        this.getData();
    },
    methods: {
        addNewSuccess() {
          if(this.isActionMenuOpen == 'new') {
            this.query.page == 1;
            this.getData();
          }
          this.toggleActionMenu("");
        },
        toggleActionMenu(menu, editItem = null) {
          this.editItem = editItem;
          this.isActionMenuOpen = menu;
        },
        handleDataClick(action, payload) {
            if(action == 'edit') {
              this.toggleActionMenu('edit', payload)
            }
        },
        getData() {
            this.$store.dispatch("getSettingPromotionLocalProduct", {
              ...this.query
            });
        },
        deleteData(item) {
            const confirmed = confirm('Are you sure you want to delete this?')
            
            if(confirmed) {
                this.$store.dispatch("deleteSettingPromotionLocalProduct", {
                    _id: item._id
                });
            }
        },
    },
    watch: {
        query: {
            deep: true,
            handler: function () {
                if (this.query.page >= 1) {
                    this.getData();
                }
            },
        }
    },
    computed: {
      pageMeta() {
          return this.$store.state.setting.promotionLocalProduct.pageMeta || [];
      },
      data() {
          return this.$store.state.setting.promotionLocalProduct.data || [];
      },
      listingOptions() {
          return {
              hasSelected: false,
              hasNo: true,
              actions: ['delete', 'edit'],
              queryOptions: {
                  sortBy: [],
                  sortDirection: [],
              },
              schema: [
                  {
                      label: "Product",
                      key: 'product',
                      value: (record) => {
                          if(!record.product) {
                              return 'N/A';
                          }

                          return record.product.name;
                      },
                  },
                  {
                      label: "Order",
                      key: 'order'
                  },
                  {
                      label: "Origin Price",
                      key: 'originPrice'
                  },
                  {
                      label: "Promotion Price",
                      key: 'promotionPrice'
                  },
                  {
                      label: "Promotion Percentage",
                      key: 'promotionPercentage',
                      value: (record) => {
                          return '<span style="color: '+record.promotionPercentageColor+'">'+ record.promotionPercentage +'</span>'
                      },
                  }
              ],
          };
      }
    },
  };
  </script>
  
  <style>
  </style>